import { ProductDetailsAPI } from '../../../types/salesforce/api/products/product-details-api';
import { TerminalDetailsDTO } from '../../../types/salesforce/dto/terminal/terminal-details-dto';
import { CENTS_IN_ONE_RAND } from '../../currency';

export function getProductApiFromDTO(terminal: TerminalDetailsDTO): ProductDetailsAPI {
  const acquiringChannels = terminal.acquiring_channel ? terminal.acquiring_channel.split(';') : [];
  const description = terminal.description ? terminal.description.split(/\r?\n/) : [];
  const extraBenefits = terminal.extra_benefits ? terminal.extra_benefits.split(/\r?\n/) : [];
  const containedItems = terminal.set_contains ? terminal.set_contains.split(/\r?\n/) : [];
  const uniquePaymentMethods = (terminal.allowedPaymentMethods || []).filter(
    (value, index, array) => array.indexOf(value) === index,
  );

  const productDetails: ProductDetailsAPI = {
    productId: terminal.id,
    productName: terminal.name,
    acquiringChannels: acquiringChannels,
    description: description,
    containedItems: containedItems,
    deliveryOptions: terminal.delivery_options,
    imageUrl: terminal.picture,
    isCardPresent: terminal.card_present,
    tagline: terminal.tagline,
    extraBenefits: extraBenefits,
    isProductCategory: !!terminal.is_product_category,
    productCategoryName: terminal.product_category,
    retailFeeVatExclusive: terminal.retail_fee_vat_excl
      ? terminal.retail_fee_vat_excl * CENTS_IN_ONE_RAND
      : undefined,
    allowedPaymentMethods: uniquePaymentMethods,
  };
  return productDetails;
}
